import React from 'react';
import { motion } from "framer-motion";
import { TiArrowForward } from "react-icons/ti";

const Decagon = ({ title, company, timeline, roles=[] }) => {
  return (
    <motion.div
    initial={{opacity: 0}}
    animate={{opacity: 1}}
    transition={{delay: 0.1}}
    className="w-full"
    >
        <h3 className='flex gap-1 font-medium text-xl font-titleFont'> {title} <span className='text-textGreen tracking-wide'>@{company}</span>
        </h3>
        <p className='text-sm mt-1 font-medium text-textDark'>{timeline}</p>
        <ul className='mt-6 flex flex-col gap-3'>
        {
            roles.map(role=>{
                return <li className='text-base gap-2 text-textDark flex'>
                <span className='text-textGreen mt-1'>
                    <TiArrowForward />
                </span>
                {" "}
                {role}
            </li>
            })
        }

        </ul>
    </motion.div>
  )
}

export default Decagon